import { useState, useEffect, RefObject } from "react";

interface UseTooltipPositionProps {
  isVisible: boolean;
  targetRef: RefObject<HTMLElement>;
  tooltipWidth?: number;
  tooltipHeight?: number;
  margin?: number;
  padding?: number;
  forceBelow?: boolean;
}

export const useTooltipPosition = ({
  isVisible,
  targetRef,
  tooltipWidth = 352,
  tooltipHeight = 300,
  margin = 8,
  padding = 16,
  forceBelow = false,
}: UseTooltipPositionProps) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (isVisible && targetRef.current) {
      const rect = targetRef.current.getBoundingClientRect();

      let left = rect.left + rect.width / 2 - tooltipWidth / 2;
      let top = rect.bottom + margin;

      if (left < padding) left = padding;
      if (left + tooltipWidth > window.innerWidth - padding) {
        left = window.innerWidth - tooltipWidth - padding;
      }

      if (!forceBelow) {
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;

        if (
          spaceBelow < tooltipHeight + margin + padding &&
          spaceAbove > spaceBelow
        ) {
          top = rect.top - tooltipHeight - margin;
          if (top < padding) top = padding;
        }
      }

      setPosition({ top, left });
    }
  }, [
    isVisible,
    targetRef,
    tooltipWidth,
    tooltipHeight,
    margin,
    padding,
    forceBelow,
  ]);

  return position;
};
